import { createFileRoute } from '@tanstack/react-router';
import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '~/lib/api';
import { Button } from '~/components/button';

export const Route = createFileRoute('/_authed/billing')({
  component: Billing,
});

const tierPrice: Record<string, string> = {
  foundation: '£0',
  optimization: '£19 / month',
  transformation: '£89 / month',
};

function Billing() {
  const { data } = useQuery({ queryKey: ['me'], queryFn: api.me });
  const user = data?.user;
  const tier = user?.tier ?? 'foundation';

  const checkout = useMutation({
    mutationFn: (target: 'optimization' | 'transformation') => api.checkout({ tier: target }),
    onSuccess: (r) => {
      window.location.href = r.url;
    },
  });
  const portal = useMutation({
    mutationFn: api.portal,
    onSuccess: (r) => {
      window.location.href = r.url;
    },
  });

  return (
    <section className="mx-auto max-w-2xl px-4 py-16">
      <h1 className="text-2xl font-semibold tracking-tight">billing</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        current tier: <b>{tier}</b> ({tierPrice[tier]}).
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        <TierCard
          name="Optimization"
          price="£19 / month"
          active={tier === 'optimization'}
          disabled={checkout.isPending || tier === 'optimization'}
          onSelect={() => checkout.mutate('optimization')}
        />
        <TierCard
          name="Transformation"
          price="£89 / month"
          active={tier === 'transformation'}
          disabled={checkout.isPending || tier === 'transformation'}
          onSelect={() => checkout.mutate('transformation')}
        />
      </div>

      {tier !== 'foundation' && (
        <div className="mt-8">
          <Button
            variant="secondary"
            disabled={portal.isPending}
            onClick={() => portal.mutate()}
          >
            manage in Stripe portal
          </Button>
        </div>
      )}
    </section>
  );
}

function TierCard(props: {
  name: string;
  price: string;
  active: boolean;
  disabled: boolean;
  onSelect: () => void;
}) {
  return (
    <div className="rounded-[var(--radius)] border border-border p-5">
      <div className="text-lg font-semibold">{props.name}</div>
      <div className="text-sm text-muted-foreground mt-1">{props.price}</div>
      <div className="mt-5">
        <Button size="sm" disabled={props.disabled} onClick={props.onSelect}>
          {props.active ? 'current' : 'upgrade'}
        </Button>
      </div>
    </div>
  );
}
